import { Breadcrumbs } from '@change/ds-core-ui';

import { useTopicBreadcrumbs } from './hooks/useTopicBreadcrumbs';

export const TopicBreadcrumbs: React.FC = () => {
	const {
		data: { items },
	} = useTopicBreadcrumbs();

	return <Breadcrumbs data-qa="breadcrumb-navigation" items={items} maxVisibleTablet={3} />;
};
